<template>

	<div class="h400">
		<div class="text-center mt100" style="font-size: 120px">
			404
		</div>
		<div class="text-center">
			您访问的页面不存在！
		</div>

		<div class="text-center">
			<router-link to="/">回到首页</router-link>
		</div>

	</div>


</template>

<script>

	export default {

		computed: {

		},
		components: {

		},
		created(){

		}
	}

</script>




// WEBPACK FOOTER //
// 404.vue?42c75eac